import React, { useCallback, useEffect, useContext, useState } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { InputForm } from './subcomponents/inputForm/InputForm';
import { CheckAvailabilityContext } from '../CheckAvailabilityContext';
import '../styles/check-availability.scss';

export const ShippingService = () => {
  const {
    onSubmitForm,
    showLoader,
    quantity,
    onError,
    storeId,
    itemId,
    price,
    zip,
  } = useContext(CheckAvailabilityContext);

  const [getShipping, { data, loading, error }] = useDataModel('shipping', {
    variables: {
      itemId,
      storeId,
      zipCode: zip,
      quantity,
      price
    },
    fetchPolicy: 'no-cache'
  }, true);
  const onSubmit = useCallback((event) => {
    if (event) {
      event.preventDefault();
    }
    getShipping();
  }, []);

  const [errorMessage, updateErrorMessage] = useState(null);
  useEffect(() => {
    if (error && onError) {
      onError(error);
    }
    if (error) {
      updateErrorMessage(error.message);
    } else if (data && onSubmitForm) {
      onSubmitForm(data);
      updateErrorMessage(null);
    }
  }, [data, error, loading]);

  if (loading && showLoader) {
    return (
      <span className="segment-spinner segment-spinner--small" />
    );
  }

  return (
    <div className="check-availability">
      <InputForm onSubmit={onSubmit} errorMessage={errorMessage} />
    </div>
  );
};